export default __webpack_public_path__ + "static/media/300.4deffa82.gif";